import React from "react";
import PageWithConfigurator from "../../global/pageWithConfigurator/pageWithConfigurator";

import instructorClosingConversionModule from "./instructorClosingConversion/index";
import instructorFirstVisitConversionsModule from "./instructorFirstVisitConversions/index";
import instructorUtilizationModule from "./instructorUtilization/index";

const pageConfig = {
  pageName: "Instructor Performance",
  configuratorWidth: 400,
  moduleList: [
    instructorFirstVisitConversionsModule,
    instructorClosingConversionModule,
    instructorUtilizationModule
  ]
};

const InstructorPerformancePage = ({ notifications }) => (
  <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />
);

export default InstructorPerformancePage;
